import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { wipeNewClientState } from 'redux/modules/newClient';
import { showStripeError } from 'redux/modules/billing';
import NewLocationFormStep1 from './NewLocationFormStep1';
import NewLocationFormStep2 from './NewLocationFormStep2';
import NewLocationStep3 from './NewLocationStep3';
import NewLocationSummary from './NewLocationSummary';
import { Spinner } from 'components';
import * as styles from './NewLocation.scss';
var NewLocation = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme,
    formValues: _objectSpread(_objectSpread({}, state.newClient), {}, {
      orgConfig: _objectSpread(_objectSpread({}, state.newClient.orgConfig), {}, {
        managementFee: function () {
          try {
            return parseInt(state.teamManagement.partnerDetails.terms.llManagedMonthlyFee);
          } catch (e) {
            return 99;
          }
        }()
      })
    }),
    settingAdsPaymentMethod: state.billing.settingAdsPaymentMethod
  };
}, {
  showStripeError: showStripeError,
  wipeNewClientState: wipeNewClientState
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(NewLocation, _Component);

  var _super = _createSuper(NewLocation);

  function NewLocation() {
    _classCallCheck(this, NewLocation);

    return _super.apply(this, arguments);
  }

  _createClass(NewLocation, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.wipeNewClientState();
    }
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          contractInfo = _this$props.contractInfo,
          formValues = _this$props.formValues,
          formStep = _this$props.formStep,
          totals = _this$props.totals;
      return /*#__PURE__*/React.createElement("div", null, contractInfo ? /*#__PURE__*/React.createElement("div", null, formStep === 1 && /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.colWrap
      }, /*#__PURE__*/React.createElement(NewLocationFormStep1, {
        formValues: formValues,
        contractInfo: contractInfo
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.colWrap
      }, this.props.formValues.orgConfig.billingMethod !== 'existing_license' && /*#__PURE__*/React.createElement(NewLocationSummary, {
        contractInfo: contractInfo,
        orgConfig: formValues.orgConfig,
        totals: totals,
        formValues: formValues
      }))), formStep === 2 && /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.colWrap
      }, /*#__PURE__*/React.createElement(NewLocationFormStep2, {
        formValues: formValues,
        contractInfo: contractInfo,
        totals: totals
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.colWrap
      }, this.props.formValues.orgConfig.billingMethod !== 'existing_license' && /*#__PURE__*/React.createElement(NewLocationSummary, {
        contractInfo: contractInfo,
        orgConfig: formValues.orgConfig,
        totals: totals,
        formValues: formValues
      }))), formStep === 3 && /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.colWrap
      }, this.props.formValues.orgConfig.billingMethod !== 'existing_license' && /*#__PURE__*/React.createElement(NewLocationSummary, {
        contractInfo: contractInfo,
        style: {
          marginTop: 24
        },
        orgConfig: formValues.orgConfig,
        totals: totals,
        formValues: formValues
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.colWrap
      }, /*#__PURE__*/React.createElement(NewLocationStep3, {
        formValues: formValues,
        totals: totals,
        contractInfo: contractInfo
      })))) : /*#__PURE__*/React.createElement("div", {
        style: {
          height: 75,
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })));
    }
  }]);

  return NewLocation;
}(Component)) || _class);
export { NewLocation as default };